module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ball_bounced.9fb3ed60.svg";